export const fullScreenButtonClick = (id = '') => {
  const fullscreenButton: any = document.querySelector('#image-gallery-fullscreen-button' + id);
  fullscreenButton && fullscreenButton.click();
};
